const GeoRegionTypes = {
  FETCH_GEOREGION_OBJECTS: "FETCH_GEOREGION_OBJECTS",
  UPDATE_CURRENT_REGION_OBJECT: "UPDATE_CURRENT_REGION_OBJECT",
};

export default GeoRegionTypes;



// WEBPACK FOOTER //
// ./src/action-types/geoRegion.js